<template>
  <div>
    <AudioPlayer :stage-id="stage.id" :src="stage.audio" label="Packing instructions" :material-id="stage.id" :disabled="disabled" @action="$emit('action', $event)" />
    <div class="two-columns">
      <div><h3>Tap a card to pack or remove it.</h3><div class="card-grid"><button v-for="item in items" :key="item.id" :class="{ chosen: state.selected.includes(item.id) }" :aria-pressed="state.selected.includes(item.id)" :disabled="disabled" @click="$emit('action', { type: 'bag_toggle', item_id: item.id })">{{ item.label }} {{ state.selected.includes(item.id) ? '✓' : '+' }}</button></div><p v-if="!stage.distractors.length" class="placeholder-note">{{ stage.distractor_placeholder }}</p></div>
      <div class="bag-zone"><MediaPlaceholder :material="stage.bag" /><h3>In Ann’s Bag</h3><p>{{ state.selected.length ? state.selected.join(', ') : 'Your bag is empty.' }}</p></div>
    </div>
    <button :disabled="disabled" @click="$emit('action', { type: 'check' })">CHECK MY BAG</button>
    <TaskFeedback :checked="state.checked" :correct="state.correct === true" :success-message="stage.success_message" />
    <MediaPlaceholder v-if="state.checked && state.correct" :material="stage.closing" />
  </div>
</template>
<script>
import AudioPlayer from './AudioPlayer.vue';
import MediaPlaceholder from './MediaPlaceholder.vue';
import TaskFeedback from './TaskFeedback.vue';
export default { components: { AudioPlayer, MediaPlaceholder, TaskFeedback }, props: { stage: Object, state: Object, disabled: Boolean }, emits: ['action'], computed: { items() { return [...this.stage.supplies, ...this.stage.distractors]; } } };
</script>

